import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		ticketOneThemeId: 0,//门票一级主题ID
		ticketCityId: 0,//门票
		hotelData: "",
		versionLimit: 1,//1正常 2过期
    merchantNewField:{
      merchantType:3,
      proCatalogList:[]
    }
	},
	getters: {

	},
	mutations: {
		//获取门票一级主题ID
		setTicketOneThemeId(state, value) {
			state.ticketOneThemeId = value;
		},
		//门票城市ID
		setTicketCityId(state, value) {
			state.ticketCityId = value;
		},
		//酒店数据
		setHotelData(state, data) {
			state.hotelData = data;
		},
		setVersionData(state, value) {
			state.versionLimit = value;
		},
    setMerchantNewField(state,value){
      state.merchantNewField = value
    }
	},
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js